import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { IconButtonLink as LiquidityIconButtonLink } from '@c2fo/liquidity';

interface IconButtonLinkProps extends Omit<React.ComponentProps<typeof LiquidityIconButtonLink>, 'as'> {
  to: string;
}

export const IconButtonLink = forwardRef<HTMLAnchorElement, IconButtonLinkProps>((props, ref) => {
  const Component = LiquidityIconButtonLink as React.ComponentType<IconButtonLinkProps & { as: typeof Link }>;
  return <Component {...props} ref={ref} as={Link} />;
});

IconButtonLink.displayName = 'IconButtonLink';
